import { Ear } from "lucide-react";
import type { ModuleSpec } from "../types";

export const socialListeningSpec: ModuleSpec = {
  id: "social-listening",
  icon: Ear,
  i18n: {
    namespace: "modules",
    titleKey: "socialListening.title",
    descriptionKey: "socialListening.description",
  },
  nav: {
    path: "/social-listening",
    group: "observe",
    order: 20,
  },
  meta: {
    status: "active",
    description: "Monitor social media mentions and sentiment",
  },
};
